<template>
    <div class="products_in">
        <div class="button_add mb-4">
            <button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" v-on:click="add_prod()">
                <span class="fal  fa-eject mr-1"></span>
                {{__t('SELECT_PRODUCT')}}
            </button>
        </div>

        <div class="form-group mt-2">
            <label class="form-label" for="bolt_rest">
                {{__t("SPECIAL_PRODUCTS")}}
            </label>

            <div class="" v-if="this.special_products.length > 0">
                <div class="special_items card p-2" v-for="prod in this.special_products">
                    <div class="d-flex flex-row align-items-center p-2" >
                          <span class="position-absolute remove" v-on:click.stop.prevent="remove_item(prod)" >
                              <span  class="btn btn-danger btn-sm btn-icon waves-effect waves-themed">
                                  <i class="fal fa-times"></i>
                              </span>
                        </span>

                        <div class="icon-stack display-3 flex-shrink-0">
                            <i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
                            <i class="fas fa-address-book icon-stack-1x opacity-100 color-primary-500"></i>
                        </div>
                        <div class="ml-3">
                            <strong>{{prod.product_code + " | Price:" + prod.price}}</strong>
                            <br>
                            {{prod.title}}
                        </div>
                    </div>

                    <div class="d-block" v-if="labels.length > 0">
                        <v-select
                            v-model="prod.labels"
                            class="imc_reasons"
                            @input="work_labels"
                            :reduce="label => label.type"
                            label="txt"
                            multiple
                            :options="labels"
                            :filterable="false"
                        >
                            <template slot="no-options">
                                {{__t('LABELS')}}
                            </template>

                            <template slot="option"  slot-scope="option">
                                <div class="d-center">
                                    {{ option.txt }}
                                </div>
                            </template>
                        </v-select>
                    </div>
                </div>

            </div>
        </div>


        <product_modal_list
            :selected_ids="special_ids"
            :is_multiple=true
            show_trigger="show_spec"
            push_trigger_list="on_spec_list_selected"
        >

        </product_modal_list>
    </div>
</template>

<script>


import product_modal_list from "../../../../catalog/products/modal_list/product_modal_list";
import vSelect from 'vue-select'
export default {
    name: "uklon_market_labels",
    props : {
        location : {
            type : Object
        }
    },
    components : {
        product_modal_list,
        vSelect
    },

    data() {
        return {
            is_load: false,
            products : [],
            labels : [],
            is_set_data : false,
            show_catalog_choice : false,
        }
    },
    created() {
        EventBus.$on('on_spec_list_selected', this.set_prods);
        this.load_labels();
    },

    beforeDestroy() {
        EventBus.$off('on_spec_list_selected', this.set_prods);
    },
    methods : {

        work_labels(cur_val) {
            console.log('SET_LABEL',cur_val);
        },

        async load_labels() {
            agr_api.get('/aggregators/uklon-market/labels').then(({data}) => {
                if(data.status == "operation_success") {
                    let resp = data.data;
                    this.labels = resp;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        set_prods(prods) {
            this.special_products = [];
            if(prods.length > 0) {
                prods.map(item => {
                    let to_push = {
                        'product_code' : item.product_code,
                        'product_id' : item.id,
                        'price' : item.price,
                        'title' : item.title,
                        "labels" : [
                            'special_offer_5',
                        ]
                    };
                    this.special_products.push(to_push);
                })
            }
        },


        add_prod() {
            EventBus.$emit('show_spec');
        },

        remove_item(prod) {
            console.log('remove',prod);
            this.special_products = this.special_products.filter(item => {
                return parseInt(item.product_id) != parseInt(prod.product_id);
            });
        }
    },
    computed : {
        special_products : {
            get :function () {
                let res = [];
                if(this.location.hasOwnProperty("special_products")) {
                    return this.location.special_products;
                }
                return res;
            },
            set: function (val) {
                if(this.location.hasOwnProperty("special_products")) {
                    this.location.special_products = val;
                }
            }
        },

        special_ids () {
            try {
                return this.special_products.map((item => {
                    return parseInt(item.product_id);
                }));
            }
            catch (e) {

            }

            return [];
        },

        active_labels : {
            get :function () {
                if(this.location.hasOwnProperty("special_products")) {
                    if(this.location.special_products.hasOwnProperty("labels")) {
                        return this.location.special_products.labels;
                    }
                }

                return [];
            },
            set : function(val) {

            }
        }
    }
}
</script>

<style scoped>
.remove {
    right: 25px;
}
</style>
